import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import Attendance from "@/pages/Attendance";
import Quiz from "@/pages/Quiz";
import QuizTake from "@/pages/QuizTake";
import QuizEdit from "@/pages/QuizEdit";
import Assessment from "@/pages/Assessment";
import Gradebook from "@/pages/Gradebook";
import EmployeePortal from "@/pages/EmployeePortal";
import SelfAttendance from "@/pages/SelfAttendance";
import Settings from "@/pages/Settings";
import { Loader2 } from "lucide-react";

function Protected({ children, roles, superOnly }) {
  const { user, booting } = useAuth();
  if (booting || user === null)
    return <div className="flex h-screen items-center justify-center bg-slate-50"><Loader2 className="h-8 w-8 animate-spin text-blue-600" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to={user.role === "admin" ? "/dashboard" : "/portal"} replace />;
  if (superOnly && !user.is_super)
    return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function RootRedirect() {
  const { user, booting } = useAuth();
  if (booting || user === null)
    return <div className="flex h-screen items-center justify-center bg-slate-50"><Loader2 className="h-8 w-8 animate-spin text-blue-600" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/dashboard" : "/portal"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/presensi" element={<SelfAttendance />} />
            <Route path="/" element={<RootRedirect />} />
            <Route path="/dashboard" element={<Protected roles={["admin"]}><Dashboard /></Protected>} />
            <Route path="/karyawan" element={<Protected roles={["admin"]}><Employees /></Protected>} />
            <Route path="/penilaian" element={<Protected roles={["admin"]}><Assessment /></Protected>} />
            <Route path="/gradebook" element={<Protected roles={["admin"]}><Gradebook /></Protected>} />
            <Route path="/pengaturan" element={<Protected roles={["admin"]} superOnly><Settings /></Protected>} />
            <Route path="/portal" element={<Protected roles={["employee"]}><EmployeePortal /></Protected>} />
            <Route path="/kehadiran" element={<Protected><Attendance /></Protected>} />
            <Route path="/kuis" element={<Protected><Quiz /></Protected>} />
            <Route path="/kuis/:id/edit" element={<Protected roles={["admin"]}><QuizEdit /></Protected>} />
            <Route path="/kuis/:id" element={<Protected roles={["employee"]}><QuizTake /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
